import init from './init.js';

const width = 1080;
const height = 1920;
const offsetX = 115;
const offsetY = 359;
PIXI.settings.TARGET_FPMS = 0.01;

const SCENES = ['taroko', 'shuinandong', 'salt-mountain', 'fire-mountain'];
const LIFES = ['butterfly', 'dragon'];
const EFFECTS = ['wind', 'powder', 'fire', 'rain'];

const gradientFrag = `
  precision mediump float;

  varying vec2 vTextureCoord;

  uniform float mid;

   float getValue(float y) {
    if (y > mid + 0.15) return 1.0;
    if (y < mid - 0.15) return 0.0;

    return (y - mid + 0.15) / 0.3;
  }

  void main(void)
  {
    gl_FragColor = vec4(getValue(vTextureCoord.y), 0.0, 0.0, 1.0);
  }
`;

function random(from, to) {
  return from + Math.floor(Math.random() * to);
}

function generateLayers() {
  let obj = {
    scene: SCENES[random(0, 4)],
    life: LIFES[random(0, 2)],
  };

  obj.effect =
    obj.life === 'butterfly' ? EFFECTS[random(0, 2)] : EFFECTS[random(2, 2)];

  return obj;
}

let layers = generateLayers();

const manifest = {
  width,
  height,
  offsetX,
  offsetY,
  bundles: [
    {
      name: 'preload',
      root: 'assets/6/',
      assets: [
        {
          name: 'background',
          srcs: 'background/8-background-1.png',
        },
        {
          name: 'title',
          srcs: 'title/3-title-1.png',
        },
        {
          name: 'cloud',
          srcs: 'cloud/cloud-0.json',
        },
        {
          name: 'pot',
          srcs: `pot/7-potted-${baseIndex + 1}.png`,
        },
        {
          name: 'seed',
          srcs: 'seed/seed.json',
        },
      ],
    },
    {
      name: 'background',
      root: 'assets/6/',
      assets: [
        {
          name: `scene-${layers.scene}`,
          srcs: `scene/${layers.scene}.json`,
        },
        {
          name: `life-${layers.life}`,
          srcs: `life/${layers.life}.json`,
        },
        {
          name: `effect-${layers.effect}`,
          srcs: `effect/${layers.effect}.json`,
        },
      ],
    },
    {
      name: 'final',
      root: 'assets/6/',
      assets: [
        {
          name: 'scene-taroko',
          srcs: 'scene/taroko.json',
        },
        {
          name: 'scene-shuinandong',
          srcs: 'scene/shuinandong.json',
        },
        {
          name: 'scene-fire-mountain',
          srcs: 'scene/fire-mountain.json',
        },
        {
          name: 'scene-salt-mountain',
          srcs: 'scene/salt-mountain.json',
        },
        {
          name: 'life-butterfly',
          srcs: 'life/butterfly.json',
        },
        {
          name: 'life-dragon',
          srcs: 'life/dragon.json',
        },
        {
          name: 'effect-fire',
          srcs: 'effect/fire.json',
        },
        {
          name: 'effect-powder',
          srcs: 'effect/powder.json',
        },
        {
          name: 'effect-rain',
          srcs: 'effect/rain.json',
        },
        {
          name: 'effect-wind',
          srcs: 'effect/wind.json',
        },
      ],
    },
  ],
};

async function main() {
  const { app, getAssetOfBundle, Sprite, AnimatedSprite } = await init(
    manifest
  );

  const preloadAssets = await PIXI.Assets.loadBundle('preload');
  PIXI.Assets.backgroundLoadBundle('background');

  const getPreloadAsset = getAssetOfBundle('preload', preloadAssets);
  const background = new Sprite(getPreloadAsset('background'));
  background.position.x = 0;
  background.position.y = 0;
  background.width = width;
  background.height = height;

  const title = new Sprite(getPreloadAsset('title'));
  const pot = new Sprite(getPreloadAsset('pot'));
  const cloud = new AnimatedSprite(
    getPreloadAsset('cloud').animations['1-cloud']
  );
  cloud.animationSpeed = 0.6;
  cloud.loop = false;
  cloud.onComplete = () => {
    cloud.visible = false;
  };

  cloud.gotoAndPlay(0);
  cloud.visible = true;
  setInterval(() => {
    cloud.visible = true;
    cloud.gotoAndPlay(0);
  }, 8000);

  const seed = new AnimatedSprite(getPreloadAsset('seed').animations['4-seed']);
  seed.loop = false;
  seed.play();
  seed.animationSpeed = 0.5;
  seed.interactive = true;
  seed.hitArea = new PIXI.Rectangle(395, 356, 78, 155);
  seed.alpha = 0;

  seed.onComplete = () => {
    seed.gotoAndStop(0);

    setTimeout(() => {
      seed.play(0);
    }, 6000);
  };

  const middleContainer = new PIXI.Container();
  app.stage.addChild(background, title, pot, seed, middleContainer, cloud);

  async function play(rep) {
    if (rep !== 1) {
      layers = generateLayers();
    }
    seed.fadeIn(3000);
    seed.position.x = offsetX;
    seed.position.y = offsetY;

    function onDragStart(e) {
      this.dragging = true;
      this.alpha = 0.5;
      this.startMousePosition = {
        x: e.global.x,
        y: e.global.y,
      };
      this.startLocalPosition = {
        x: this.x,
        y: this.y,
      };
    }

    const seedTargetBound = new PIXI.Rectangle(
      0 + offsetX,
      600 + offsetY,
      850,
      272
    );

    function onDragEnd(e) {
      this.dragging = false;
      this.alpha = 1;

      if (seedTargetBound.contains(e.global.x, e.global.y)) {
        scene.visible = true;
        scene.play();
        seed.fadeOut(3000);
      }
    }

    function onDragMove(e) {
      if (this.dragging) {
        this.position.x =
          this.startLocalPosition.x + e.global.x - this.startMousePosition.x;
        this.position.y =
          this.startLocalPosition.y + e.global.y - this.startMousePosition.y;
      }
    }

    seed
      .on('mousedown', onDragStart)
      .on('touchstart', onDragStart)
      .on('mouseup', onDragEnd)
      .on('mouseupoutside', onDragEnd)
      .on('touchend', onDragEnd)
      .on('touchendoutside', onDragEnd)
      .on('mousemove', onDragMove)
      .on('touchmove', onDragMove);

    const backgroundAssets = await PIXI.Assets.loadBundle('background');
    const getBackgroundAsset = getAssetOfBundle('background', backgroundAssets);

    const assets = await PIXI.Assets.loadBundle(
      rep === 1 ? 'background' : 'final'
    );
    const getAsset = getAssetOfBundle(
      rep === 1 ? 'background' : 'final',
      assets
    );

    const scene = new AnimatedSprite(
      getAsset(`scene-${layers.scene}`).animations[layers.scene]
    );
    scene.animationSpeed = 0.2;
    scene.visible = false;
    scene.loop = false;

    const life = new AnimatedSprite(
      getAsset(`life-${layers.life}`).animations[layers.life]
    );

    life.animationSpeed = 0.3;
    life.visible = false;
    life.loop = false;
    life.interactive = true;
    life.anchor.set(0.5, 0);
    life.position.x = width / 2;

    scene.onComplete = () => {
      console.log(layers);
      if (layers.scene === 'taroko') {
        scene.textures = scene.textures.slice(10);
        scene.loop = true;
        scene.play();
      }
      if (layers.scene === 'fire-mountain') {
        console.log('fire-mountain');
        scene.textures = scene.textures.slice(10);
        scene.loop = true;
        scene.play();
      }

      life.visible = true;
      life.play();
    };

    const effectTextures = getAsset(`effect-${layers.effect}`).animations[
      layers.effect
    ];
    const effect = new AnimatedSprite(
      layers.effect === 'fire'
        ? [...effectTextures, ...effectTextures]
        : effectTextures
    );

    effect.animationSpeed = layers.effect === 'fire' ? 0.6 : 0.5;

    effect.loop = false;
    effect.visible = false;

    life.onComplete = () => {
      life.visible = false;
      setTimeout(() => {
        life.visible = true;

        life.gotoAndPlay(0);

        if (Math.random() > 0.5) {
          life.scale.x *= -1;
        }

        life.position.y = Math.random() * 300 + offsetY;
      }, random(8, 8) * 1000);
    };

    life.on('pointerdown', () => {
      life.stop();
      life.visible = false;
      setTimeout(() => {
        effect.visible = true;
        effect.play();
      }, 1000);
    });

    effect.onComplete = () => {
      effect.visible = false;

      setTimeout(() => {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0xff3300);
        graphics.drawRect(0, 0, width, height);
        graphics.endFill();

        const gradientFilter = new PIXI.Filter(null, gradientFrag, { mid: 0 });
        graphics.filters = [gradientFilter];

        const gradientAni = (delta) => {
          gradientFilter.uniforms.mid += delta / 30;

          const mask = new PIXI.Sprite(
            app.renderer.generateTexture(
              graphics,
              PIXI.SCALE_MODES.NEAREST,
              1,
              new PIXI.Rectangle(0, 0, width, height)
            )
          );

          scene.mask = mask;

          if (gradientFilter.uniforms.mid > 1) {
            scene.mask = null;
            scene.visible = false;
            app.ticker.remove(gradientAni);

            play();
          }
        };

        app.ticker.add(gradientAni);
      }, 1000);
    };
    middleContainer.removeChildren();

    middleContainer.addChild(scene, seed, life, effect);
  }

  play(1);
  await PIXI.Assets.loadBundle('final');
}

main();
